export default __webpack_public_path__ + "assets/images/3658762a0aa086b7aec691afb8615221.png";